<!--
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-11-17 16:49:37
 * @LastEditTime: 2022-01-10 14:35:00
 * @FilePath: /teacher-h5/src/views/error.vue
-->
<template>
  <div class="http404">
    404
  </div>
</template>

<script>
export default {
  name: '404',
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style scoped>
.http404 {
  font-size: 200px;
  text-align: center;
  padding-top: 200px;
}
</style>
